import React, { Component } from 'react';
import config from 'react-global-configuration';

import { Link } from 'react-router-dom';

import { Tabs, Tab } from 'react-bootstrap';
// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import getLocale from '../../../i18n/getLocale';


class StaffPaymentsInternationalTab extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      payment_order_id: '',
      training_certification_staff_payments_international: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.botaoEditOrderPayment = this.botaoEditOrderPayment.bind(this);

    this.locale = getLocale();
  }
  
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }
  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }
  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.training_certification_staff_payments_international)) {
      this.setState({training_certification_staff_payments_international: newProps.training_certification_staff_payments_international});
    }
  }
  
  botaoEditOrderPayment (cell, row) {
    var dados = this.state.training_certification_staff_payments_international;
    var payment_order_id = '';
    var code = '';
    dados.map(function(dado, index){
      if (dado.id == cell) {
        payment_order_id = dado.payment_order_id;
        code = dado.payment_order_code;
      }
    });
    return (
      <Link to={'/ordem/pagamento/editar/' + payment_order_id}> {code}</Link>
    );
  }

  render() {
    return (
<div>
  <BootstrapTable data={this.state.training_certification_staff_payments_international} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Tripulantes.EditarFuncionario.tabPagamentos.tabDiariaInternacional.tabela.semPagamentosEmAberto}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>
    <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.Tripulantes.EditarFuncionario.tabPagamentos.tabDiariaInternacional.tabela.ID}</TableHeaderColumn>
    <TableHeaderColumn dataField="id" dataFormat={this.botaoEditOrderPayment} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.EditarFuncionario.tabPagamentos.tabDiariaInternacional.tabela.CodigoTreinamento}</TableHeaderColumn>
    <TableHeaderColumn dataField="period" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.EditarFuncionario.tabPagamentos.tabDiariaInternacional.tabela.Periodo}</TableHeaderColumn>
    <TableHeaderColumn dataField="training" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.EditarFuncionario.tabPagamentos.tabDiariaInternacional.tabela.Treinamento}</TableHeaderColumn>
    <TableHeaderColumn dataField="training_code" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.EditarFuncionario.tabPagamentos.tabDiariaInternacional.tabela.NumeroERev}</TableHeaderColumn>
    <TableHeaderColumn dataField="daily_paid" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.EditarFuncionario.tabPagamentos.tabDiariaInternacional.tabela.Diarias}</TableHeaderColumn>
    <TableHeaderColumn dataField="daily_value" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.EditarFuncionario.tabPagamentos.tabDiariaInternacional.tabela.ValorDiaria}</TableHeaderColumn>
    <TableHeaderColumn dataField="daily_total" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.EditarFuncionario.tabPagamentos.tabDiariaInternacional.tabela.TotalEmDiarias}</TableHeaderColumn>
    <TableHeaderColumn dataField="daily_currency" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.EditarFuncionario.tabPagamentos.tabDiariaInternacional.tabela.Moeda}</TableHeaderColumn>
  </BootstrapTable>
</div>
    );
  }
}

export default StaffPaymentsInternationalTab;



// WEBPACK FOOTER //
// ./src/Components/Staffs/Elements/StaffPaymentsInternationalTab.js